export default __webpack_public_path__ + "static/media/remove_circle.101accdc.svg";